import { Amplify, API, graphqlOperation } from "aws-amplify";
import * as mutations from "../data/graphql/mutations";

export const authService = {
  login(email, password) {
    return Amplify.Auth.signIn(email, password);
  },
  confirmLogin(
    user, // Return object from Auth.signIn()
    code, // Confirmation code
    mfaType = 'SMS_MFA' // MFA Type e.g. SMS_MFA, SOFTWARE_TOKEN_MFA
  ) {
    return Amplify.Auth.confirmSignIn(user, code, mfaType);
  },
  getMfaDeviceCode(user){
    return Amplify.Auth.setupTOTP(user)
  },
  verifyMfaDeviceCode(user, code){
    return Amplify.Auth.verifyTotpToken(user, code)
  }
};

export const signUpUser = async (variables) => {
  return await API.graphql(graphqlOperation(mutations.signupUser, variables));
};
